/**
 * User Metrics contributions to the shared FinTechOps dashboard, plus the
 * roster/non-roster split every hierarchy consumer needs up front.
 */
import moment from 'moment';
import { UserMetricsParsedData } from '../UserMetricsInterfaces';
import { UserMetricsDashboardItems } from '../../fintech-ops-dashboard/FinTechOpsDataInterfaces';
import { OptionItem } from '../../FinTechOpsDataProcessingFunctions';
import { ALL_APPLICATIONS, MANAGER_ROSTER, SKYNET_ALL } from '../../FinTechOpsConstants';
import { aggregateMetricsData } from 'src/utilities/CommonUtilities';
import { USER_METRICS_DASHBOARD_COLUMN_LIST, USER_METRICS_DASHBOARD_MEASURE_COLUMN_LIST } from '../UserMetricsConstants';

export function returnSelectedAllAppNameCustom(items: string[]): OptionItem[] {
  const itemsOptions: OptionItem[] = [];
  let valueForSelector = 1;
  if (items != undefined && items.length > 0) {
    items.forEach((element) => {
      if (element != SKYNET_ALL && element != 'common') {
        itemsOptions.push({ label: element, value: element });
      }
      valueForSelector++;
    });
  }
  return itemsOptions;
}

// Calculations for FinTechOps DashBoard User Metrics section
export const createOpsUserMetricsData = (appliedFiltersData: UserMetricsParsedData[]): UserMetricsDashboardItems => {
  const considerableData = appliedFiltersData.filter((item: UserMetricsParsedData) => {
    return item.application !== ALL_APPLICATIONS && item.application !== 'common' && !item.application.toLowerCase().includes('skynet');
  });

  const distinctApplications: string[] = [];
  const distinctMonths_YYYY_MM_DD: string[] = [];
  const currentMonth_YYYY_MM_DD = moment().startOf('month').format('YYYY-MM-DD');

  let appplicationViewCount = 0;

  let currentMonthAppWithMoreUniqueUsersCount = 0;
  let currentMonthAppWithMoreUniqueUsers = '';

  let currentMonthMostViewed = 0;
  let currentMonthMostViewedApplication = '';

  const aggregatedData = aggregateMetricsData(USER_METRICS_DASHBOARD_COLUMN_LIST, considerableData, USER_METRICS_DASHBOARD_MEASURE_COLUMN_LIST) || [];

  aggregatedData.forEach((item: UserMetricsParsedData) => {
    //changed logic to application_type wise top application and application count
    const { application_type, log_month } = item;
    appplicationViewCount += item.measure_value;

    if (!distinctApplications.includes(application_type)) {
      distinctApplications.push(application_type);
    }

    if (!distinctMonths_YYYY_MM_DD.includes(log_month)) {
      distinctMonths_YYYY_MM_DD.push(log_month);
    }

    if (item.log_month === currentMonth_YYYY_MM_DD && item.user_login_count_distinct > currentMonthAppWithMoreUniqueUsersCount) {
      currentMonthAppWithMoreUniqueUsersCount = item.user_login_count_distinct;
      currentMonthAppWithMoreUniqueUsers = item.application_type;
    }

    if (item.log_month === currentMonth_YYYY_MM_DD && item.measure_value > currentMonthMostViewed) {
      currentMonthMostViewed = item.measure_value;
      currentMonthMostViewedApplication = item.application_type;
    }
  });

  let noOfDays = 0;
  distinctMonths_YYYY_MM_DD.forEach((eachDistinctMonth: string) => {
    if (eachDistinctMonth !== currentMonth_YYYY_MM_DD) {
      const daysInThisMOnth = moment(eachDistinctMonth, 'YYYY-MM-DD').daysInMonth();
      noOfDays += daysInThisMOnth;
    } else {
      const daysInThisMOnth = moment(eachDistinctMonth, 'YYYY-MM-DD').daysInMonth() - moment().date();
      noOfDays += daysInThisMOnth;
    }
  });

  const avgViewCountPerApplication = appplicationViewCount / (noOfDays * distinctApplications?.length);

  return {
    total_applications: distinctApplications?.length || 0,
    avg_view_per_application: isNaN(avgViewCountPerApplication) ? '0' : `${Number(avgViewCountPerApplication).toFixed(0)}`, // Avergae viewcount of Application excluding "All Applications" "Skynet" and "common" divided by total number of days  `${Number(avgViewCountPerApplication).toFixed(0)}`, // Avergae viewcount of Application excluding "All Applications" "Skynet" and "common" divided by total number of days
    app_most_unique_users: currentMonthAppWithMoreUniqueUsers,
    most_viewed_application: currentMonthMostViewedApplication
  };
};

/**
 * Returns two lists of UserManagerParsed Data, One where the application/applicationType == MANAGER_ROSTER
 * And the other is for everything else
 * @param fullData
 */
export const returnManagerRosterData = (fullData: UserMetricsParsedData[]): [UserMetricsParsedData[], UserMetricsParsedData[]] => {
  // MANAGER_ROSTER constant value is 'Manager Roster' (with space)
  const managerRosterData = fullData.filter((item) => item.application_type === MANAGER_ROSTER);
  const nonManagerRosterData = fullData.filter((item) => item.application_type !== MANAGER_ROSTER);
  return [managerRosterData, nonManagerRosterData];
};
